import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    description: 'Order Overview header',
    defaultMessage: 'Order Overview',
    id: 'qTST55',
  },
});
